/**
 * usePopupTopOffset
 * 팝업 top 위치 계산.
 *  - anchor="top" (기본): title-bar 상단 (= 비상공지사항 바로 밑)
 *      → 비상공지 마퀴 바만 노출, TRIPPANG 로고/검색/메뉴 등은 popup이 덮음
 *  - anchor="bottom": title-bar 하단 (= 로고/검색 바 바로 밑)
 *      → 공지 바 + 타이틀바(로고/검색)까지 노출, popup 은 그 아래에서 시작
 *
 * title-bar 없으면 0 (전체 viewport).
 * resize/scroll 시 자동 재계산.
 */
import { useState, useLayoutEffect } from "react";

function compute(anchor: "top" | "bottom"): number {
  if (typeof document === "undefined") return 0;
  const tb = document.getElementById("title-bar");
  if (!tb) return 0;
  const rect = tb.getBoundingClientRect();
  return Math.max(0, anchor === "bottom" ? rect.bottom : rect.top);
}

export function usePopupTopOffset(anchor: "top" | "bottom" = "top"): number {
  const [top, setTop] = useState<number>(() => compute(anchor));
  useLayoutEffect(() => {
    const measure = () => setTop(compute(anchor));
    measure();
    window.addEventListener("resize", measure);
    window.addEventListener("scroll", measure, { passive: true });
    return () => {
      window.removeEventListener("resize", measure);
      window.removeEventListener("scroll", measure);
    };
  }, [anchor]);
  return top;
}
